export default {
    Vote: function(obj){
        return {
            id: obj.id || null,
            uid: obj.uid || null,
            candidateId: obj.candidateId || null,
            reason: obj.reason || null,
            gender: obj.gender || null,
            age: obj.age || null,
            district: obj.district || null,
            date: obj.date || new Date(),
        }
    },
    User: function(obj){
        return {
            uid: obj.uid || null,
            name: obj.name || null,
            picture: obj.picture || null,
        }
    },
    Candidate: function(obj){
        return {
            id: obj.id || null,
            number: obj.number || null,
            fullname: obj.fullname || null,
            party: obj.party || null,
            picture: obj.picture || null,        
        }
    },
    districts: [
        { label: "คลองเตย", value: "khlong_toei" },
        { label: "คลองสาน", value: "khlong_san" },
        { label: "คลองสามวา", value: "khlong_sam_wa" },
        { label: "คันนายาว", value: "khan_na_yao" },
        { label: "จตุจักร", value: "chatuchak" },
        { label: "จอมทอง", value: "chom_thong" },
        { label: "ดอนเมือง", value: "don_mueang" },
        { label: "ดินแดง", value: "din_daeng" },
        { label: "ดุสิต", value: "dusit" },
        { label: "ตลิ่งชัน", value: "taling_chan" },
        { label: "ทวีวัฒนา", value: "thawi_watthana" },
        { label: "ทุ่งครุ", value: "thung_khu" },
        { label: "ธนบุรี", value: "thon_buri" },
        { label: "บางกอกน้อย", value: "bangkok_noi" },
        { label: "บางกอกใหญ่", value: "bangkok_yai" },
        { label: "บางกะปิ", value: "bang_kapi" },
        { label: "บางขุนเทียน", value: "bang_khun_thian" },
        { label: "บางเขน", value: "bang_khen" },
        { label: "บางคอแหลม", value: "bang_kho_laem" },
        { label: "บางแค", value: "bang_khae" },
        { label: "บางซื่อ", value: "bang_sue" },
        { label: "บางนา", value: "bang_na" },
        { label: "บางบอน", value: "bang_bon" },
        { label: "บางพลัด", value: "bang_phlat" },
        { label: "บางรัก", value: "bang_rak" },
        { label: "บึงกุ่ม", value: "bueng_kum" },
        { label: "ปทุมวัน", value: "pathum_wan" },
        { label: "ประเวศ", value: "prawet" },
        { label: "ป้อมปราบศัตรูพ่าย", value: "pom_prap_sattru_phai" },
        { label: "พญาไท", value: "phaya_thai" },
        { label: "พระโขนง", value: "phra_khanong" },
        { label: "พระนคร", value: "phra_nakhon" },
        { label: "ภาษีเจริญ", value: "phasi_charoen" },
        { label: "มีนบุรี", value: "min_buri" },
        { label: "ยานนาวา", value: "yan_nawa" },
        { label: "ราชเทวี", value: "ratchathewi" },
        { label: "ราษฎร์บูรณะ", value: "rat_burana" },
        { label: "ลาดกระบัง", value: "lat_krabang" },
        { label: "ลาดพร้าว", value: "lat_phrao" },
        { label: "วังทองหลาง", value: "wang_thonglang" },
        { label: "วัฒนา", value: "watthana" },
        { label: "สวนหลวง", value: "suan_luang" },
        { label: "สะพานสูง", value: "saphan_sung" },
        { label: "สัมพันธวงศ์", value: "samphanthawong" },
        { label: "สาทร", value: "sathon" },
        { label: "สายไหม", value: "sai_mai" },
        { label: "หนองแขม", value: "nong_khaem" },
        { label: "หนองจอก", value: "nong_chok" },
        { label: "ห้วยขวาง", value: "huai_khwang" },
        { label: "หลักสี่", value: "lak_si" },
    ],
    reasons: [
        'การเดินทาง',
        'การศึกษา',
        'ความปลอดภัยในชีวิตและทรัพย์สิน',
        'ทุจริตคอร์รัปชัน',
        'ปัญหาปากท้อง',
        'ระบบบริการสุขภาพ',
        'สิ่งแวดล้อม (ฝุ่น, สภาพอากาศ, ขยะ)',
        'สิ่งอำนวยความสะดวกใน กทม.',
    ]
}